"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decrypt = decrypt;
const tslib_1 = require("tslib");
const crypto_1 = tslib_1.__importDefault(require("crypto"));
const evp_bytestokey_1 = tslib_1.__importDefault(require("evp_bytestokey"));
/**
 * 复刻 `@fegobull/util` 的 AES 加解密算法，保证与 FEGO `fc-apiEncode` 控件产出兼容。
 *
 * - 算法：AES-256-CBC（OpenSSL `aes256` 别名等价）
 * - 密钥派生：OpenSSL EVP_BytesToKey（MD5，无 salt），与 `@fegobull/util` 一致
 * - 编码：hex
 */
/** OpenSSL EVP_BytesToKey 派生（无 salt）。第三参数为 key 的 bit 长度，第四参数为 iv 的 byte 长度。 */
function deriveKeys(password) {
    return (0, evp_bytestokey_1.default)(password, false, 256, 16);
}
function createDecipher(password) {
    const { key, iv } = deriveKeys(password);
    return crypto_1.default.createDecipheriv('aes-256-cbc', key, iv);
}
/**
 * AES-256-CBC 解密（hex → utf8）。与 FEGO `fc-apiEncode` 控件配套使用。
 *
 * @param message hex 编码的密文
 * @param password 派生密钥用的口令（本组件为 `'avatar-frame'`）
 * @returns 解密后的 utf8 明文
 */
function decrypt(message, password) {
    const decipher = createDecipher(password);
    return decipher.update(`${message}`, 'hex', 'utf8') + decipher.final('utf8');
}
